/* build 1784419643 */
/* ============================================================
   SOMNEI Theme JS \u2014 Cart drawer, Offer Picker, Sticky ATC

   Subscription/discount mechanism (until Seal Subscriptions installed):
   - Offer card has data-selling-plan-id (optional, for Seal)
   - User toggles Subscribe & Save checkbox
   - When subscription:
       * If selling_plan_id present \u2192 use Shopify-native selling_plan (Seal path)
       * Else \u2192 fall back to discount code (SAVE15) applied via:
           - cart_attributes.discount_code = SAVE15
           - Checkout button \u2192 /checkout?discount=SAVE15
   ============================================================ */

(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Config (read from DOM where available)
  // ---------------------------------------------------------------------------

  var FREE_SHIPPING_THRESHOLD_CENTS = 5000;             // $50
  var DEFAULT_SUBSCRIPTION_DISCOUNT_CODE = 'SAVE15';
  var DEFAULT_SUBSCRIPTION_DISCOUNT_PERCENT = 15;

  // ---------------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------------

  // cart.js amounts arrive already converted to the presentment currency by Shopify,
  // so this only needs the right symbol/format \u2014 never a second conversion.
  function formatMoney(cents) {
    var fx = window.somneiFx;
    // fx.fmt now renders whole numbers in every currency incl. USD (8/31)
    if (fx && fx.fmt) return fx.fmt(cents);
    return '$' + Math.round(cents / 100);
  }

  // USD-denominated theme constants (gift values, _was properties) DO need converting
  // before display when a local currency is active.
  function usdToDisplayCents(usdCents) {
    var fx = window.somneiFx;
    return (fx && fx.isLocal()) ? fx.raw(usdCents) : usdCents;
  }

  // Gift manifest shared by the one-shot ATC add and the reconciler. The checkout-visible
  // label is written in the visitor's currency; BOTH writers must produce identical strings
  // or the reconciler's stale-check would churn cart lines forever.
  function fxGiftLabel(usdCents) {
    var fx = window.somneiFx;
    var txt = (fx && fx.isLocal()) ? fx.fmt(fx.raw(usdCents)) : '$' + (usdCents / 100).toFixed(2);
    return '-' + txt;
  }
  var GIFT_RIDES = {
    // main variant id -> gifts per unit (mysteryOnce rides only with the 2-pack)
    46865498308662: { per: 1, mystery: false, headGuard: 1 }, // Peach 1 Trimmer (+1 head guard 7/20)
    46865931108406: { per: 2, mystery: false, headGuard: 2 }, // Peach 2 Trimmers (2 head guards added 7/19; mystery retired 7/16)
    46748931260470: { guasha: true },           // Electric Gua Sha (lavender oil, 1/unit)
    46909881942070: { mousse2pk: true },        // Body Blur 2 Bottles: 1 mitt/unit (7/20 direct-priced tiers; 1-bottle = no gifts)
    46939524661302: { mousse3pk: true },        // Body Blur 3 Bottles: 1 mitt + 1 oil per unit (7/20)
    46940967796790: { luxe: true },             // Somnei LUXE+ Blush: 1 Glow Oil per unit (7/21)
    46940967829558: { luxe: true },             // Somnei LUXE+ Sonic Pink
    46940967862326: { luxe: true },             // Somnei LUXE+ Icy
    46940967895094: { luxe: true }              // Somnei LUXE+ Mint
  };
  var GIFT_SKUS = {
    oil:     { vid: 46866019319862, usd: 2900 },
    brush:   { vid: 46875083309110, usd: 1000 },
    mystery: { vid: 46884781097014, usd: 1000 },
    lavOil:  { vid: 46865879171126, usd: 1500 },
    cloth:   { vid: 46910774870070, usd: 1200 },
    headGuard: { vid: 46931892928566, usd: 1000 },
    luxeBlades: { vid: 46946509914166, usd: 1990 },
    howtoGuide: { vid: 46982115098678, usd: 1500 }
  };
  // Gift lines to send IN THE SAME /cart/add.js call as the main product (kills the
  // 3-sequential-request ~4s drawer wait). The reconciler stays as the safety net for
  // qty changes, removals, partial adds, and stale carts.
  function oneShotGiftItems(variantId, qty) {
    var ride = GIFT_RIDES[variantId];
    if (!ride) return [];
    if (ride.guasha) {
      return [{ id: GIFT_SKUS.lavOil.vid, quantity: Math.min(qty, 3), properties: { _gift: 'true' } }];
    }
    if (ride.mousse2pk) {
      return [{ id: GIFT_SKUS.cloth.vid, quantity: Math.min(qty, 3), properties: { _gift: 'true' } }];
    }
    if (ride.luxe) {
      return [
        { id: GIFT_SKUS.oil.vid, quantity: Math.min(qty, 3), properties: { _gift: 'true' } },
        { id: GIFT_SKUS.luxeBlades.vid, quantity: Math.min(qty, 3), properties: { _gift: 'true' } },
        { id: GIFT_SKUS.howtoGuide.vid, quantity: Math.min(qty, 3), properties: { _gift: 'true' } }
      ];
    }
    if (ride.mousse3pk) {
      return [
        { id: GIFT_SKUS.cloth.vid, quantity: Math.min(qty, 3), properties: { _gift: 'true' } },
        { id: GIFT_SKUS.oil.vid,   quantity: Math.min(qty, 3), properties: { _gift: 'true' } }
      ];
    }
    var n = Math.min(ride.per * qty, 3);
    var items = [
      { id: GIFT_SKUS.oil.vid,   quantity: n, properties: { _gift: 'true' } },
      { id: GIFT_SKUS.brush.vid, quantity: n, properties: { _gift: 'true' } }
    ];
    if (ride.mystery) items.push({ id: GIFT_SKUS.mystery.vid, quantity: 1, properties: { _gift: 'true' } });
    if (ride.headGuard) items.push({ id: GIFT_SKUS.headGuard.vid, quantity: Math.min(ride.headGuard * qty, 3), properties: { _gift: 'true' } });
    return items;
  }

  // Single source of truth for gift quantities: given cart items, return desired qty per
  // gift vid. Used by BOTH reconcileGift (safety net) and the batched qty stepper in
  // changeQty - they can never disagree because they share this math.
  function computeGiftTargets(items) {
    var PILLOW_PACK = { 46710047506486: 1, 46710047539254: 2, 46710047572022: 3 };
    var GUASHA_PACK = { 46748931260470: 1 };
    var SHAVER_1PACK_VID = 46865498308662; // 1 Trimmer: 1 oil + 1 brush (7/15)
    var SHAVER_2PACK_VID = 46865931108406; // 2 Trimmers: 2 oils + 2 brushes + Mystery Gift
    var MOUSSE_1PK_VID = 46909881876534; // Body Blur 1 Bottle - no gifts (7/20 direct-priced tiers)
    var MOUSSE_2PK_VID = 46909881942070; // Body Blur 2 Bottles: 1 mitt/unit (7/20)
    var MOUSSE_3PK_VID = 46939524661302; // Body Blur 3 Bottles: 1 mitt + 1 oil per unit (7/20)
    var MOUSSE_ADDON_VID = 46925237682230; // Extra Mousse Bottle (cart upsell, $19.99) - counts as a bottle unit so 1 bottle + add-on = 2 -> unlocks the mitt (7/18)
    var LUXE_PACK = { 46940967796790: 1, 46940967829558: 1, 46940967862326: 1, 46940967895094: 1 }; // Somnei LUXE+ colors: 1 Glow Oil per unit (7/21)
    // Free gifts: Lavender Facial Oil rides with the Electric Gua Sha (1 per unit). The Peach 1-pack
    // carries 1 oil + 1 brush; the 2-pack carries 2 oils + 2 brushes + 1 Mystery Gift (mystery stays
    // 2-pack-only as the tier differentiator). Legacy pillow entries kept inert (desired=0 self-cleans).
    var GIFTS = [
      { vid: 46865879171126, usd: 1500, withGuaSha: true },
      { vid: 46866019319862, usd: 2900, withShaver2: true, withMousse3pk: true, withLuxe: true },
      { vid: 46910774870070, usd: 1200, withMousseMitt: true },
      { vid: 46875083309110, usd: 1000, withShaver2: true },
      { vid: 46931892928566, usd: 1000, withShaver2: true }, // Head Guard - rides every Peach (7/20)
      { vid: 46946509914166, usd: 1990, withLuxe: true }, // 4 Precision Blade Edges - rides every LUXE+ (7/21)
      { vid: 46982115098678, usd: 1500, withLuxe: true }, // LUXE+ How-To Guide (printed insert) rides every LUXE+ (7/24)
      { vid: 46884781097014, usd: 1000, mysteryOnce: false }, // mystery retired 7/16: desired=0 self-cleans stale carts
      { vid: 46729679110198, usd: 1500, withPillow: true },
      { vid: 46822806650934, usd: 1200, withPillow: false },
      { vid: 46822806782006, usd: 1000, withPillow: false }
    ];
    var pillowUnits = 0, guaShaUnits = 0, pack1Units = 0, pack2Units = 0, mousse1Units = 0, mousse2pkUnits = 0, mousse3pkUnits = 0, addonUnits = 0, addonLine = null, luxeUnits = 0, lines = {};
    (items || []).forEach(function (it) {
      if (PILLOW_PACK[it.variant_id]) pillowUnits += PILLOW_PACK[it.variant_id] * it.quantity;
      if (GUASHA_PACK[it.variant_id]) guaShaUnits += GUASHA_PACK[it.variant_id] * it.quantity;
      if (it.variant_id === SHAVER_1PACK_VID) pack1Units += it.quantity;
      if (it.variant_id === SHAVER_2PACK_VID) pack2Units += it.quantity;
      if (it.variant_id === MOUSSE_1PK_VID) mousse1Units += it.quantity;
      if (it.variant_id === MOUSSE_ADDON_VID) { addonUnits += it.quantity; addonLine = it; }
      if (it.variant_id === MOUSSE_2PK_VID) mousse2pkUnits += it.quantity;
      if (it.variant_id === MOUSSE_3PK_VID) mousse3pkUnits += it.quantity;
      if (LUXE_PACK[it.variant_id]) luxeUnits += it.quantity;
      lines[it.variant_id] = it;
    });
    var hasMainMousse = (mousse1Units > 0 || mousse2pkUnits > 0 || mousse3pkUnits > 0);
    var targets = {};
    GIFTS.forEach(function (g) {
      var desired = g.withShaver2 ? (pack1Units + pack2Units * 2) : (g.mysteryOnce ? (pack2Units > 0 ? 1 : 0) : (g.withGuaSha ? guaShaUnits : (g.withPillow ? pillowUnits : 0)));
      if (g.withMousse3pk) desired += mousse3pkUnits;
      if (g.withLuxe) desired += luxeUnits;
      if (g.withMousseMitt) desired += mousse2pkUnits + mousse3pkUnits;
      if (desired > 3) desired = 3;
      targets[g.vid] = desired;
    });
    return { targets: targets, lines: lines, addonLine: addonLine, hasMainMousse: hasMainMousse };
  }

  function showError(container, message) {
    if (!container) return;
    container.textContent = message || 'Something went wrong. Please try again.';
    container.style.display = 'block';
  }

  function hideError(container) {
    if (!container) return;
    container.textContent = '';
    container.style.display = 'none';
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Shopify CDN thumbnail for cart drawer slots (64px @2x). Non-CDN URLs pass through untouched.
  function cartThumb(url) {
    if (!url || url.indexOf('cdn.shopify') === -1 && url.indexOf('/cdn/') === -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=128';
  }

  var SVG_MINUS =
    '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var SVG_PLUS =
    '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var SVG_TRASH =
    '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>';

  // ---------------------------------------------------------------------------
  // Klaviyo tracking (no-op if not installed)
  // ---------------------------------------------------------------------------

  var KlaviyoTracker = {
    trackAddToCart: function (offer) {
      if (typeof window._learnq === 'undefined') return;
      window._learnq.push([
        'track',
        'Added to Cart',
        {
          $value: offer.priceCents / 100,
          AddedItemSKU: offer.variantId,
          AddedItemPrice: offer.priceCents / 100,
          AddedItemType: offer.isSubscription ? 'Subscription' : 'One-Time',
          Items: [{ ProductName: offer.label, Quantity: 1, Price: offer.priceCents / 100 }]
        }
      ]);
    }
  };

  // ---------------------------------------------------------------------------
  // CartDrawer
  // ---------------------------------------------------------------------------

  function CartDrawer() {
    this.drawer            = document.querySelector('[data-cart-drawer]');
    this.overlay           = document.querySelector('[data-cart-overlay]');
    this.closeBtn          = document.querySelector('[data-cart-close]');
    this.itemsEl           = document.querySelector('[data-cart-items]');
    this.loadingEl         = document.querySelector('[data-cart-loading]');
    this.emptyEl           = document.querySelector('[data-cart-empty]');
    this.errorEl           = document.querySelector('[data-cart-error]');
    this.subtotalEl        = document.querySelector('[data-cart-subtotal]');
    this.savingsEl         = document.querySelector('[data-cart-savings]');
    this.checkoutBtn       = document.querySelector('[data-checkout-btn]');
    this.progressFill      = document.querySelector('[data-progress-fill]');
    this.progressAmount    = document.querySelector('[data-progress-amount]');
    this.progressText      = document.querySelector('[data-progress-text]');
    this.progressBar       = document.querySelector('[data-progress-bar]');
    this.threshold         = FREE_SHIPPING_THRESHOLD_CENTS;
    this._focusTrapHandler = null;
    this._previousFocus    = null;
    this._lastCart         = null;
    this.init();
  }

  CartDrawer.prototype.init = function () {
    var self = this;
    document.querySelectorAll('[data-cart-close]').forEach(function (btn) { btn.addEventListener('click', function () { self.close(); }); });
    if (this.overlay)   this.overlay.addEventListener('click', function () { self.close(); });

    // Checkout button \u2014 append ?discount=CODE if cart has subscription
    if (this.checkoutBtn) {
      this.checkoutBtn.addEventListener('click', function (e) {
        var url = self._buildCheckoutUrl();
        if (url !== '/checkout') {
          e.preventDefault();
          window.location.href = url;
        }
      });
    }
  };

  CartDrawer.prototype._buildCheckoutUrl = function () {
    if (!this._lastCart) return '/checkout';
    var hasSub = this._cartHasSubscription(this._lastCart);
    if (!hasSub) return '/checkout';
    var code = (this._lastCart.attributes && this._lastCart.attributes.discount_code) ||
               DEFAULT_SUBSCRIPTION_DISCOUNT_CODE;
    return '/checkout?discount=' + encodeURIComponent(code);
  };

  CartDrawer.prototype._cartHasSubscription = function (cart) {
    if (!cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i++) {
      var p = cart.items[i].properties || {};
      if (p._subscription === 'true' || cart.items[i].selling_plan_allocation) return true;
    }
    return false;
  };

  CartDrawer.prototype.open = function () {
    if (!this.drawer) return;
    this._previousFocus = document.activeElement;
    this.drawer.classList.add('is-open');
    if (this.overlay) this.overlay.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    this.trapFocus();
    // Optimistic: paint the last known cart instantly so the drawer never feels slow,
    // then reconcile against the live cart in the background.
    if (this._lastCart) {
      this.renderItems(this._lastCart);
      this.updateProgress(this._lastCart);
      this.updateUpsell(this._lastCart);
      this.updateProtectionCard(this._lastCart);
    }
    this.refresh();
  };

  CartDrawer.prototype.close = function () {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    if (this.overlay) this.overlay.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    this.releaseFocus();
    if (this._previousFocus && typeof this._previousFocus.focus === 'function') {
      this._previousFocus.focus();
    }
  };

  CartDrawer.prototype.trapFocus = function () {
    var self = this;
    this._focusTrapHandler = function (e) {
      if (e.key === 'Escape') { self.close(); return; }
      if (e.key !== 'Tab') return;
      var nodes = self.drawer.querySelectorAll(
        'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', this._focusTrapHandler);

    var nodes = this.drawer.querySelectorAll(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (nodes[0]) nodes[0].focus();
  };

  CartDrawer.prototype.releaseFocus = function () {
    if (this._focusTrapHandler) {
      document.removeEventListener('keydown', this._focusTrapHandler);
      this._focusTrapHandler = null;
    }
  };

  CartDrawer.prototype.refresh = function () {
    var self = this;
    // Serialize refresh chains. Two overlapping mutations (rapid +/- clicks) can
    // interleave their reconcile ops and paint the UI from a mid-mutation cart
    // snapshot that no later render corrects. If a chain is in flight, queue at
    // most one trailing refresh; it re-fetches after ALL ops settle.
    if (self._refreshBusy) { self._refreshAgain = true; return; }
    self._refreshBusy = true;
    // Only show the spinner on a cold open. If we already have a cart painted,
    // refresh silently in the background so the drawer never flashes empty.
    if (!this._lastCart) {
      if (this.loadingEl) this.loadingEl.style.display = 'block';
      if (this.itemsEl)   this.itemsEl.style.display   = 'none';
      if (this.emptyEl)   this.emptyEl.style.display    = 'none';
    }
    if (this.errorEl)   hideError(this.errorEl);

    fetch('/cart.js', {
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) { if (!res.ok) throw new Error('Cart fetch failed'); return res.json(); })
      .then(function (cart) {
        self._lastCart = cart;
        if (self.loadingEl) self.loadingEl.style.display = 'none';
        return self.reconcileGift(cart).then(function () {
          return self.reconcileProtection(self._lastCart);
        }).then(function () {
          var c = self._lastCart;
          self.renderItems(c);
          self.updateProgress(c);
          self.updateCartIconBadge(c);
          self.updateUpsell(c);
          self.updateProtectionCard(c);
          self._setBusy(false);
          self._refreshBusy = false;
          if (self._refreshAgain) { self._refreshAgain = false; self.refresh(); }
        });
      })
      .catch(function () {
        if (self.loadingEl) self.loadingEl.style.display = 'none';
        // If the cart is rate-limited (429) but we already have it painted, keep showing
        // the cached cart rather than a scary error. Only hard-fail on a cold load.
        if (!self._lastCart) showError(self.errorEl, 'Could not load cart. Please refresh the page.');
        self._setBusy(false);
        self._refreshBusy = false;
        if (self._refreshAgain) { self._refreshAgain = false; self.refresh(); }
      });
  };

  // Free gift-with-purchase: keep the Satin Eye Mask quantity = number of Crescent pillows
  // in the cart (1/2/3 per pack), capped at 3. Loop-safe: only mutates when qty differs, and the
  // 100%-off automatic discount (Crescent \u2192 eye mask) makes it free at cart + checkout.
  CartDrawer.prototype.reconcileGift = function (cart) {
    var self = this;
    var H = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    // Gift math lives in computeGiftTargets (shared with the batched qty stepper in
    // changeQty - single source of truth). Gift label removed 8/3: the FREE GIFT
    // automatic discount strikes the real price through natively at checkout, so no
    // label property is written or re-stamped.
    var giftState = computeGiftTargets(cart.items);
    var lines = giftState.lines, addonLine = giftState.addonLine, hasMainMousse = giftState.hasMainMousse;

    var ops = [];
    Object.keys(giftState.targets).forEach(function (gvid) {
      var desired = giftState.targets[gvid];
      var item = lines[gvid] || null;
      var current = item ? item.quantity : 0;
      if (current === desired) return;
      var withRetry = function (makeReq) {
        return makeReq().then(function (r) {
          if (r.ok) return r;
          return new Promise(function (res) { setTimeout(res, 700); }).then(makeReq);
        });
      };
      if (!item && desired > 0) {
        ops.push(function () {
          return withRetry(function () { return fetch('/cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: [{ id: parseInt(gvid, 10), quantity: desired, properties: { _gift: 'true' } }] }) }); });
        });
      } else if (item) {
        ops.push(function () {
          return withRetry(function () { return fetch('/cart/change.js', { method: 'POST', headers: H, body: JSON.stringify({ id: item.key, quantity: desired, properties: desired > 0 ? { _gift: 'true' } : undefined }) }); });
        });
      }
    });
    // orphaned Backup Bottle add-on (main mousse offer removed) \u2192 drop it
    if (addonLine && !hasMainMousse) {
      ops.push(function () { return fetch('/cart/change.js', { method: 'POST', headers: H, body: JSON.stringify({ id: addonLine.key, quantity: 0 }) }); });
    }
    if (!ops.length) return Promise.resolve(false);

    // run sequentially (Shopify cart API rejects parallel mutations), then re-read the cart once
    var chain = Promise.resolve();
    ops.forEach(function (op) { chain = chain.then(op); });
    return chain
      .then(function () { return fetch('/cart.js', { headers: H }); })
      .then(function (r) { return r.json(); })
      .then(function (newCart) {
        if (newCart && newCart.items) self._lastCart = newCart;
        return true;
      }).catch(function () { return false; });
  };

  // Warranty + Shipping Protection ($4.95) \u2014 a $0-cost add-on line, DEFAULT ON (opt-out).
  // Auto-added whenever the cart has >=1 real (non-gift) item and the shopper hasn't turned it
  // off; removed if they toggle it off (localStorage flag) or the cart empties to gifts only.
  // Rendered as the footer toggle card, NOT as an item row (renderItems skips its variant).
  CartDrawer.prototype.reconcileProtection = function (cart) {
    var self = this;
    var PROTECTION_VID = 46926424801334;
    var H = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    var realItems = 0, line = null;
    (cart.items || []).forEach(function (it) {
      if (it.variant_id === PROTECTION_VID) { line = it; return; }
      if (!(it.properties && it.properties._gift)) realItems += it.quantity;
    });
    var optedIn = false;
    try { optedIn = localStorage.getItem('somnei_protect_on') === '1'; } catch (e) {}
    var desired = (realItems > 0 && optedIn) ? 1 : 0;  // DEFAULT OFF (opt-in) \u2014 only added if shopper turns it on
    var req = null;
    if (desired === 1 && !line) {
      req = fetch('/cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: [{ id: PROTECTION_VID, quantity: 1, properties: { _protection: 'true' } }] }) });
    } else if (desired === 0 && line) {
      req = fetch('/cart/change.js', { method: 'POST', headers: H, body: JSON.stringify({ id: line.key, quantity: 0 }) });
    } else if (line && line.quantity > 1) {
      req = fetch('/cart/change.js', { method: 'POST', headers: H, body: JSON.stringify({ id: line.key, quantity: 1 }) });
    }
    if (!req) return Promise.resolve(false);
    return req
      .then(function () { return fetch('/cart.js', { headers: H }); })
      .then(function (r) { return r.json(); })
      .then(function (nc) { if (nc && nc.items) self._lastCart = nc; return true; })
      .catch(function () { return false; });
  };

  // Sync the footer toggle card to cart state (show when there's a real item; reflect on/off).
  CartDrawer.prototype.updateProtectionCard = function (cart) {
    var self = this;
    var card = document.querySelector('[data-cart-protect]');
    if (!card) return;
    var PROTECTION_VID = 46926424801334;
    var realItems = 0, hasProtection = false;
    (cart.items || []).forEach(function (it) {
      if (it.variant_id === PROTECTION_VID) { hasProtection = true; return; }
      if (!(it.properties && it.properties._gift)) realItems += it.quantity;
    });
    card.style.display = realItems > 0 ? 'flex' : 'none';
    var toggle = card.querySelector('[data-protect-toggle]');
    if (toggle) {
      toggle.checked = hasProtection;
      if (!toggle._somneiBound) {
        toggle._somneiBound = true;
        toggle.addEventListener('change', function () {
          try {
            if (toggle.checked) localStorage.setItem('somnei_protect_on', '1');
            else localStorage.removeItem('somnei_protect_on');
          } catch (e) {}
          // Dim the drawer and spin the ring while the add/remove settles, the same
          // overlay changeQty uses. refresh() clears it on BOTH its success and catch
          // paths, so it can never stick on.
          self._setBusy(true);
          self.refresh();
        });
      }
    }
  };

  CartDrawer.prototype.renderItems = function (cart) {
    if (!this.itemsEl) return;

    var footerEl = document.querySelector('.cart-drawer__footer');
    if (!cart.items || cart.items.length === 0) {
      if (this.emptyEl)    this.emptyEl.style.display = 'flex'; // matches its flex-column CSS so the icon centers
      var asr0 = document.querySelector('[data-cart-assure]'); if (asr0) asr0.style.display = 'none';
      this.itemsEl.style.display = 'none';
      if (footerEl) footerEl.style.display = 'none'; // no $0.00 subtotal / dead checkout button on empty carts
      if (this.subtotalEl) this.subtotalEl.textContent = formatMoney(0);
      if (this.savingsEl)  this.savingsEl.style.display = 'none';
      return;
    }

    if (this.emptyEl) this.emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = '';
    var asr1 = document.querySelector('[data-cart-assure]'); if (asr1) asr1.style.display = 'flex';
    this.itemsEl.style.display = 'block';

    var html = '';
    var displayTotal = 0;
    var savingsTotal = 0;
    var discountSavings = 0; // real Shopify discounts only (no gift/_was inflation) \u2014 shown on LUXE-quiet carts
    var PROTECTION_VID = 46926424801334;

    // paid items first, free gifts underneath
    var itemsSorted = cart.items.slice().sort(function (a, b) {
      var ga = (a.properties && a.properties._gift) ? 1 : 0;
      var gb = (b.properties && b.properties._gift) ? 1 : 0;
      return ga - gb;
    });

    // Premium (quiet) gift treatment: LUXE-only carts say "Included", not green FREE (Jack 7/21).
    // Any Peach/Mousse/GuaSha main product in the cart keeps the green DTC treatment.
    var LUXE_MAIN_VIDS = { 46940967796790: 1, 46940967829558: 1, 46940967862326: 1, 46940967895094: 1 };
    var OTHER_MAIN_VIDS = { 46865498308662: 1, 46865931108406: 1, 46909881876534: 1, 46909881942070: 1, 46939524661302: 1, 46748931260470: 1, 46925237682230: 1 };
    var PEACH_MAIN_VIDS = { 46865498308662: 1, 46865931108406: 1 };
    var MOUSSE_MAIN_VIDS = { 46909881876534: 1, 46909881942070: 1, 46939524661302: 1 };
    var hasLuxeMain = false, hasOtherMain = false, hasPeach = false, hasMousse = false;
    for (var lm = 0; lm < itemsSorted.length; lm++) {
      var lmp = itemsSorted[lm].properties || {};
      if (LUXE_MAIN_VIDS[itemsSorted[lm].variant_id]) hasLuxeMain = true;
      if (OTHER_MAIN_VIDS[itemsSorted[lm].variant_id] && !lmp._gift) hasOtherMain = true;
      if (PEACH_MAIN_VIDS[itemsSorted[lm].variant_id]) hasPeach = true;
      if (MOUSSE_MAIN_VIDS[itemsSorted[lm].variant_id] && !lmp._gift) hasMousse = true;
    }
    var luxQuiet = hasLuxeMain && !hasOtherMain;
    var peachPink = hasPeach && !luxQuiet; // Peach cart \u2192 green FREE turns Peach pink (Jack 7/22)
    var mousseLav = hasMousse && !luxQuiet && !peachPink; // Mousse cart \u2192 green FREE turns lavender (Jack 7/24)

    for (var i = 0; i < itemsSorted.length; i++) {
      var item = itemsSorted[i];
      var props = item.properties || {};
      // Warranty + Shipping Protection: counted in the subtotal but shown as the footer toggle, not a row.
      if (item.variant_id === PROTECTION_VID || props._protection === 'true') {
        displayTotal += (typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price);
        continue;
      }
      var isSub = props._subscription === 'true' || !!item.selling_plan_allocation;
      var pct   = DEFAULT_SUBSCRIPTION_DISCOUNT_PERCENT / 100;

      // Final price reflects Shopify automatic discounts (e.g. Wind Down Ritual \u221220%) live via cart.js.
      var afterAuto = (typeof item.final_line_price === 'number') ? item.final_line_price : item.line_price;
      var origLine  = (typeof item.original_line_price === 'number') ? item.original_line_price : item.line_price;
      var displayPrice = afterAuto;
      var lineSave = 0;
      var lineWas = 0;

      // Shopify automatic discount on the line (reflected live in the cart drawer)
      if (item.total_discount && item.total_discount > 0) {
        lineSave = item.total_discount;
        lineWas = origLine;
        // Peach: use the same display strikethrough the PDP shows (somneiFx STRIKE map)
        // so drawer and PDP never disagree. Display only, charged price untouched. 8/31
        if (item.variant_id === 46865498308662 && window.somneiFx && window.somneiFx.strike) {
          var _strike = window.somneiFx.strike(10999) * item.quantity;
          if (_strike > afterAuto) { lineWas = _strike; lineSave = _strike - afterAuto; }
        }
        discountSavings += item.total_discount;
      }
      // Subscription visual discount (until Seal is installed; real discount applies at checkout)
      if (isSub && !item.selling_plan_allocation) {
        var subOff = Math.round(displayPrice * pct);
        displayPrice = displayPrice - subOff;
        lineSave += subOff;
        if (!lineWas) lineWas = afterAuto;
      }
      // Subscription via Seal selling plan: the 20% lives in the allocation (compare_at vs price),
      // which cart.js does NOT always mirror into original_line_price \u2014 read it straight from the
      // allocation so the subscribe-&-save discount surfaces as was + savings (Jack 7/24).
      if (isSub && item.selling_plan_allocation) {
        var _alloc = item.selling_plan_allocation;
        if (typeof _alloc.compare_at_price === 'number' && typeof _alloc.price === 'number' && _alloc.compare_at_price > _alloc.price) {
          lineWas = _alloc.compare_at_price * item.quantity;
          lineSave = (_alloc.compare_at_price - _alloc.price) * item.quantity;
        } else if (origLine > afterAuto) {
          lineWas = origLine;
          lineSave = origLine - afterAuto;
        }
      }
      // Bundle compare-at carried as a line-item property (only when no Shopify discount on the line)
      if (lineSave === 0) {
        var wasUnit = props._was ? usdToDisplayCents(parsePriceToCents(props._was)) : 0;
        if (wasUnit > item.price) { lineSave = (wasUnit - item.price) * item.quantity; lineWas = wasUnit * item.quantity; }
      }
      // Free gift-with-purchase: show it FREE in the drawer. "Buy X Get Y" automatic discounts
      // (Crescent \u2192 eye mask 100% off) don't reflect in cart.js but DO apply at checkout, so we
      // display $0 here to match the real checkout total. GIFT_WAS values are USD cents \u2192
      // converted for display when a local currency is active.
      var GIFT_WAS = { 46865879171126: 1500, 46866019319862: 2900, 46875083309110: 1000, 46884781097014: 1000, 46729679110198: 1500, 46822806650934: 1200, 46822806782006: 1000, 46910774870070: 1200, 46931892928566: 1000, 46946509914166: 1990 };
      if (props._gift) {
        displayPrice = 0;
        // Gifts have carried REAL prices + a 100%-off FREE GIFT discount since 8/3, so the
        // cart already knows their exact worth in the presentment currency. Prefer that over
        // the USD GIFT_WAS map, which FX-rounds and drifts (SGD 148.55 vs Shopify 150.70).
        if (item.total_discount && item.total_discount > 0) {
          lineWas = item.original_line_price;
          lineSave = item.total_discount;
        } else {
          lineWas = usdToDisplayCents(GIFT_WAS[item.variant_id] || 1500) * item.quantity;
          lineSave = lineWas;
        }
      }
      displayTotal += displayPrice;
      // Savings row = full bundle value story (Jack, 7/14): every line's was\u2212now, gifts included.
      // Tier 2 reads \u2212$194.98 here; checkout's "Total savings" still shows only the real $105
      // discount \u2014 Shopify can't count $0 gifts or _was strikethroughs there.
      if (lineSave > 0) savingsTotal += lineSave;

      // cart.js returns master-res images; request a 128px CDN thumbnail (64px @2x) so the
      // drawer doesn't decode megapixel files into tiny slots. Eager: rows are visible on open.
      var img = item.image
        ? '<img class="cart-drawer__item-img" src="' + cartThumb(item.image) + '" alt="' + escapeHtml(item.title) + '" decoding="async" width="64" height="80">'
        : '<div class="cart-drawer__item-img"></div>';

      // Mousse Complete Routine: plain-English contents (variant-keyed so pre-existing carts get it too)
      var LUXE_COLOR_VIDS = { 46940967796790: 1, 46940967829558: 1, 46940967862326: 1, 46940967895094: 1 }; // Somnei LUXE+ colors \u2014 show picked color in the drawer (7/20)
      var sub = item.product_id === 9028042129462
        ? '<span class="cart-drawer__item-sub">4\u00d7 replacement blades</span>'
        : item.product_id === 9020468428854
        ? '<span class="cart-drawer__item-sub">2\u00d7 attachments</span>'
        : item.variant_id === 46909881942070
        ? '<span class="cart-drawer__item-sub">Includes 2 bottles</span>'
        : (item.variant_id === 46939524661302 ? '<span class="cart-drawer__item-sub">Includes 3 bottles</span>'
        : (LUXE_COLOR_VIDS[item.variant_id] ? '<span class="cart-drawer__item-sub">Dermaplaning Set \u00b7 ' + escapeHtml(item.variant_title || '') + '</span>'
        : (props._pack ? '<span class="cart-drawer__item-sub">' + escapeHtml(props._pack) + '</span>' : '')));
      // strikethrough already tells the savings story per line; no "You save" badges (7/14)
      var SUB_CADENCE = { 2275278902: 'Every 30 days', 2275311670: 'Every 60 days', 2275344438: 'Every 90 days' };
      var _spId = (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) ? item.selling_plan_allocation.selling_plan.id : null;
      var badge = isSub ? '<span class="cart-drawer__item-badge">' + (SUB_CADENCE[_spId] || 'Every 30 days') + '</span>' : '';
      var _qtyPfx = (props._gift && item.quantity > 1) ? (item.quantity + '× ') : '';
      var saveLine = (lineSave > 0) ? '<span class="cart-drawer__item-save">(' + _qtyPfx + 'You save ' + formatMoney(lineSave) + ')</span>' : '';

      var nowText = props._gift
        ? (luxQuiet ? '<span class="cart-drawer__incl">FREE GIFT</span>' : '<span class="cart-drawer__free-pill">FREE</span>&nbsp;' + formatMoney(0))
        : formatMoney(displayPrice);
      var priceHtml = (lineWas > displayPrice)
        ? '<span class="cart-drawer__item-price-was">' + formatMoney(lineWas) + '</span>' +
          '<span class="cart-drawer__item-price">' + nowText + '</span>'
        : '<span class="cart-drawer__item-price">' + nowText + '</span>';

      html +=
        '<div class="cart-drawer__item" data-key="' + item.key + '" data-variant-id="' + item.variant_id + '">' +
          img +
          '<div class="cart-drawer__item-info">' +
            '<p class="cart-drawer__item-title">' + escapeHtml(item.product_id === 8711024705590 ? 'Magnesium Sleep Spray' : (item.product_id === 8983319576630 ? 'The Peach\u2122' : (item.product_id === 8983610097718 ? 'After-Shave Glow Oil (60 ml)' : (item.product_title || item.title)))) + '</p>' +
            sub +
            saveLine +
            badge +
          '</div>' +
          '<div class="cart-drawer__item-end">' +
            '<div class="cart-drawer__item-price-stack">' + priceHtml + '</div>' +
            (props._gift
              ? ''
              : '<div class="cart-drawer__item-end-row">' +
                  '<button class="cart-drawer__item-remove" data-remove data-key="' + item.key + '" aria-label="Remove ' + escapeHtml(item.title) + '" title="Remove">' + SVG_TRASH + '</button>' +
                  '<div class="cart-drawer__item-qty">' +
                    '<button class="cart-drawer__qty-btn" aria-label="Decrease quantity" data-qty-decrease data-key="' + item.key + '">' + SVG_MINUS + '</button>' +
                    '<span class="cart-drawer__qty-value qty-value">' + item.quantity + '</span>' +
                    '<button class="cart-drawer__qty-btn" aria-label="Increase quantity" data-qty-increase data-key="' + item.key + '">' + SVG_PLUS + '</button>' +
                  '</div>' +
                '</div>') +
          '</div>' +
        '</div>';
    }

    this.itemsEl.innerHTML = html;

    var drawerRoot = document.getElementById('somnei-cart-drawer');
    if (drawerRoot) { drawerRoot.classList.toggle('is-lux', luxQuiet); drawerRoot.classList.toggle('is-peach', peachPink); drawerRoot.classList.toggle('is-mousse', mousseLav); }

    if (this.subtotalEl) this.subtotalEl.textContent = formatMoney(displayTotal);
    if (this.savingsEl) {
      var shownSavings = savingsTotal; // LUXE now shows full bundle-value savings like Peach/Mousse (Jack 7/24)
      if (shownSavings > 0) {
        this.savingsEl.innerHTML = '<span>Savings</span><span>-' + formatMoney(shownSavings) + '</span>';
        this.savingsEl.classList.toggle('is-lux', luxQuiet);
        this.savingsEl.style.display = 'flex';
      } else {
        this.savingsEl.style.display = 'none';
      }
    }

    this._bindItemEvents();
  };

  CartDrawer.prototype._bindItemEvents = function () {
    var self = this;
    var qtyMinus = this.itemsEl.querySelectorAll('[data-qty-decrease]');
    qtyMinus.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (self._qtyBusy) return;
        var key = btn.getAttribute('data-key');
        var item = self.itemsEl.querySelector('[data-key="' + key + '"]');
        var qtyEl = item ? item.querySelector('.qty-value') : null;
        var cur = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        var next = cur - 1;
        if (next <= 0) self.removeItem(key); else self.changeQty(key, next);
      });
    });
    var qtyPlus = this.itemsEl.querySelectorAll('[data-qty-increase]');
    qtyPlus.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (self._qtyBusy) return;
        var key = btn.getAttribute('data-key');
        var item = self.itemsEl.querySelector('[data-key="' + key + '"]');
        var qtyEl = item ? item.querySelector('.qty-value') : null;
        var cur = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        self.changeQty(key, cur + 1);
      });
    });
    var removeBtns = this.itemsEl.querySelectorAll('[data-remove]');
    removeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { if (self._qtyBusy) return; self.removeItem(btn.getAttribute('data-key')); });
    });
  };

  CartDrawer.prototype.updateProgress = function (cart) {
    if (!this.progressBar) return;

    // Use total_price for shipping threshold (real cart total, not display total)
    var total = cart.total_price;
    var remaining = this.threshold - total;
    var pct = Math.min(100, Math.round((total / this.threshold) * 100));

    if (this.progressFill) this.progressFill.style.width = pct + '%';
    if (this.progressBar)  this.progressBar.setAttribute('aria-valuenow', pct);

    if (remaining <= 0) {
      if (this.progressText)   this.progressText.textContent = '\u2726 Free shipping unlocked';
      if (this.progressAmount) this.progressAmount.textContent = '';
    } else {
      if (this.progressText)   this.progressText.textContent = "You're " + formatMoney(remaining) + ' away from free shipping';
      if (this.progressAmount) this.progressAmount.textContent = formatMoney(total);
    }
  };

  // Cart upsell: Lavender Facial Oil ($19.99, was $29.99) \u2014 shown ONLY when a trimmer (1.0 or 2.0)
  // is in the cart, NEVER alongside the gua sha (gua sha buyers already get the oil free as a gift),
  // and hidden once the paid oil is in the cart. Added with _was so the drawer shows the strikethrough
  // + "You save $10.00" like every other discounted line.
  CartDrawer.prototype.updateUpsell = function (cart) {
    var self = this;
    var items = cart.items || [];
    var TRIMMER_PIDS = { 8983319576630: 1, 8977738924086: 1 }; // Peach 2.0 + original
    var hasTrimmer = false;
    items.forEach(function (i) { if (TRIMMER_PIDS[i.product_id]) hasTrimmer = true; });

    // --- Trimmer cart upsell REMOVED 7/18 (was Exfoliating Mitt) \u2014 trimmer no longer shows a cart-drawer add-on. hasTrimmer kept (mousse card uses !hasTrimmer). ---

    // --- Mousse \u2192 Extra Bottle card ($19.99). Shows when a mousse is in cart, the add-on isn't
    //     already there, and there's no trimmer (avoid stacking two upsell cards on a cross-cart).
    //     Copy is cart-aware: exactly 1 bottle \u2192 "unlocks the free mitt"; else \u2192 "stock up & save". ---
    // --- Mousse Backup Bottle cart upsell REMOVED 7/19 per Jack (all tiers). Backup Bottle product + reconcileGift addon logic kept (AfterSell post-purchase + gift-count safety). ---

    // --- bind add buttons across both cards (both add a $19.99 line with a $29.99 strikethrough) ---
    document.querySelectorAll('[data-cart-upsell] [data-upsell-add], [data-cart-mousse-upsell] [data-upsell-add]').forEach(function (addBtn) {
      if (addBtn._somneiBound) return;
      addBtn._somneiBound = true;
      addBtn.addEventListener('click', function () {
        var vid = parseInt(addBtn.getAttribute('data-variant-id'), 10);
        if (!vid) return;
        addBtn.disabled = true;
        var label = addBtn.querySelector('.cart-drawer__addon-add-label');
        if (label) label.textContent = 'Adding\u2026';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: { _was: (addBtn.getAttribute('data-was') || '$29.99') } }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            addBtn.disabled = false;
            if (label) label.textContent = '+ Add';
            self.refresh();
          })
          .catch(function () {
            addBtn.disabled = false;
            if (label) label.textContent = '+ Add';
          });
      });
    });
  };

  CartDrawer.prototype.updateCartIconBadge = function (cart) {
    var count = cart.item_count || 0;
    // Drive Horizon's cart-icon through its OWN event (cart:update). Its component
    // toggles the visually-hidden/hidden classes, the --has-cart notch-mask class,
    // sessionStorage and the pop animation together. Doing any of that by hand
    // desyncs the pair: on pages that load with an empty cart the bubble is
    // server-rendered with visually-hidden, and a manual style.display='' never
    // removes that class - notch cut, no bubble, mangled bag icon.
    var cartLink = document.querySelector('header a[href="/cart"], a.action__cart');
    if (cartLink) {
      var oldDot = cartLink.querySelector('.somnei-cart-dot');
      if (oldDot) oldDot.parentNode.removeChild(oldDot);
      var bubbleEl = cartLink.querySelector('.cart-bubble');
      if (bubbleEl) bubbleEl.style.removeProperty('display'); // clear residue from the old manual approach
    }
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'somnei-cart-drawer', data: { itemCount: count, source: 'somnei-cart-drawer' } }
      }));
    } catch (e) {}
    // Fallback: if the cart-icon component missed the event (not yet upgraded),
    // apply exactly the class set its renderCartBubble would have applied.
    setTimeout(function () {
      var ic = document.querySelector('header cart-icon, a.action__cart cart-icon');
      if (!ic) return;
      var bc = ic.querySelector('.cart-bubble__text-count');
      var bub = ic.querySelector('.cart-bubble');
      var want = count > 99 ? '' : String(count);
      if (bc && bc.textContent.trim() !== want.trim()) {
        bc.textContent = want;
        bc.classList.toggle('hidden', count === 0);
        if (bub) bub.classList.toggle('visually-hidden', count === 0);
        ic.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
        try { sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() })); } catch (e) {}
      }
    }, 350);
    var badges = document.querySelectorAll('[data-somnei-cart-count]');
    var lbl = document.querySelector('[data-somnei-cart-items]');
    if (lbl) lbl.textContent = count === 1 ? 'item' : 'items';
    badges.forEach(function (el) {
      el.textContent = count;
      el.style.display = '';
    });
  };

  CartDrawer.prototype.changeQty = function (key, newQty) {
    var self = this;
    if (this._qtyBusy) return;
    if (this.errorEl) hideError(this.errorEl);
    this._qtyBusy = true;
    this._setBusy(true);
    var H = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    // One batched /cart/update.js: the edited line + every existing gift line's new
    // target qty (same math as the reconciler via computeGiftTargets), so a qty tap
    // costs a single mutation instead of four sequential ones. The reconciler in
    // refresh() stays as the self-healing net for anything the batch can't do
    // (adding a missing gift line, the orphaned mousse add-on).
    var base = (this._lastCart && this._lastCart.items)
      ? Promise.resolve(this._lastCart)
      : fetch('/cart.js', { headers: H }).then(function (r) { if (!r.ok) throw new Error('Cart read failed'); return r.json(); });
    base
      .then(function (cart) {
        var updates = {};
        updates[key] = newQty;
        var simulated = [];
        (cart.items || []).forEach(function (it) {
          var q = (it.key === key) ? newQty : it.quantity;
          if (q > 0) simulated.push({ variant_id: it.variant_id, quantity: q });
        });
        var targets = computeGiftTargets(simulated).targets;
        (cart.items || []).forEach(function (it) {
          if (it.key === key) return;
          var want = targets[it.variant_id];
          if (typeof want === 'number' && want !== it.quantity) updates[it.key] = want;
        });
        return fetch('/cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ updates: updates }) });
      })
      .then(function (res) { if (!res.ok) throw new Error('Change qty failed'); return res.json(); })
      .then(function () { self._qtyBusy = false; self.refresh(); })
      .catch(function () {
        self._qtyBusy = false;
        showError(self.errorEl, 'Something went wrong. Please try again.');
        self.refresh();
      });
  };

  // Busy overlay: transparent scrim + spinner over the drawer while a qty/remove
  // mutation is in flight. Blocks taps (kills rage-clicks and stale double-sends);
  // cleared when refresh() finishes painting the post-mutation cart.
  CartDrawer.prototype._setBusy = function (on) {
    if (this.drawer) this.drawer.classList.toggle('is-busy', !!on);
  };

  CartDrawer.prototype.removeItem = function (key) { this.changeQty(key, 0); };
  CartDrawer.prototype.formatMoney = formatMoney;

  // ---------------------------------------------------------------------------
  // OfferPicker (2-tier + subscribe checkbox)
  // ---------------------------------------------------------------------------

  function OfferPicker(rootEl) {
    this.root           = rootEl;
    this.cards          = rootEl.querySelectorAll('[data-offer]');
    this.subInput       = rootEl.querySelector('[data-sub-input]');
    this.subToggle      = rootEl.querySelector('[data-sub-toggle]');
    this.errorEl        = document.getElementById('somnei-cart-error');
    this.atcBtns        = document.querySelectorAll('[data-atc]');
    this.selectedCard   = null;
    this.cartDrawer     = null;
    this.discountCode   = this._readMeta('subscription_discount_code') || DEFAULT_SUBSCRIPTION_DISCOUNT_CODE;
    this.discountPct    = parseFloat(this._readMeta('subscription_discount_percent')) || DEFAULT_SUBSCRIPTION_DISCOUNT_PERCENT;
    this.init();
  }

  OfferPicker.prototype._readMeta = function (key) {
    var el = document.querySelector('meta[name="somnei-' + key + '"]');
    return el ? el.getAttribute('content') : null;
  };

  OfferPicker.prototype.init = function () {
    var self = this;
    // Pick the card with is-selected; fallback to last (Bundle is default)
    for (var i = 0; i < this.cards.length; i++) {
      if (this.cards[i].classList.contains('is-selected')) { this.selectedCard = this.cards[i]; break; }
    }
    if (!this.selectedCard && this.cards.length) this.selectedCard = this.cards[this.cards.length - 1];

    // Bind card clicks (skip clicks inside <details>/[data-no-select] \u2014 bundle dropdown)
    this.cards.forEach(function (card) {
      card.setAttribute('tabindex', '0');
      card.setAttribute('role', 'radio');
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-no-select], details')) return;
        self.selectCard(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.target.closest('[data-no-select], details')) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.selectCard(card); }
      });
    });

    // Bind subscription toggle
    if (this.subInput) {
      this.subInput.addEventListener('change', function () { self.updateAtcDisplay(); });
    }

    this.selectCard(this.selectedCard);
  };

  OfferPicker.prototype.selectCard = function (card) {
    if (!card) return;
    this.selectedCard = card;
    this.cards.forEach(function (c) {
      c.classList.remove('is-selected');
      c.setAttribute('aria-checked', 'false');
    });
    card.classList.add('is-selected');
    card.setAttribute('aria-checked', 'true');
    this.updateAtcDisplay();
  };

  OfferPicker.prototype._getSelectedOffer = function () {
    var card = this.selectedCard;
    if (!card) return null;
    var spId = card.getAttribute('data-selling-plan-id') || '';
    var titleEl = card.querySelector('.somnei-offer__title');
    var wasEl = card.querySelector('.somnei-offer__price-was');
    return {
      variantId:     card.getAttribute('data-variant-id'),
      sellingPlanId: spId ? parseInt(spId, 10) : null,
      basePriceCents: parseInt(card.getAttribute('data-base-price-cents'), 10) || 0,
      label:         card.getAttribute('data-label') || '',
      pack:          (card.getAttribute('data-label') === 'single') ? '' : (card.getAttribute('data-pack-label') || (titleEl ? titleEl.textContent.trim() : '')),
      was:           wasEl ? wasEl.textContent.trim() : ''
    };
  };

  OfferPicker.prototype.updateAtcDisplay = function () {
    var offer = this._getSelectedOffer();
    if (!offer) return;
    var isSub = !!(this.subInput && this.subInput.checked);
    var pct = this.discountPct / 100;
    var finalCents = isSub ? Math.round(offer.basePriceCents * (1 - pct)) : offer.basePriceCents;

    // ATC button
    var labelEls = document.querySelectorAll('[data-atc-label]');
    var priceEls = document.querySelectorAll('[data-atc-price]');
    labelEls.forEach(function (el) { el.textContent = isSub ? 'Subscribe & Save' : 'Add to Cart'; });
    var atcQty = window.__somneiQty || 1;
    priceEls.forEach(function (el) { el.textContent = formatMoney(finalCents * atcQty); });

    // Visible price + savings on each offer card.
    // Sub on + this card is selected \u2192 strike base price, show discounted, recompute savings.
    // Otherwise \u2192 restore the card's original markup snapshot.
    var self = this;
    this.cards.forEach(function (card) {
      var priceEl = card.querySelector('.somnei-offer__price');
      var pricingEl = card.querySelector('.somnei-offer__pricing');
      if (!priceEl || !pricingEl) return;
      var wasEl  = card.querySelector('.somnei-offer__price-was');
      var saveEl = card.querySelector('.somnei-offer__save');

      // Snapshot original text on first run
      if (card._origPrice == null) {
        card._origPrice = priceEl.textContent;
        card._origWas   = wasEl  ? wasEl.textContent  : '';
        card._origSave  = saveEl ? saveEl.textContent : '';
      }

      var base = parseInt(card.getAttribute('data-base-price-cents'), 10) || 0;
      var isThisSelected = card === self.selectedCard;

      if (isSub && isThisSelected && base > 0) {
        var newPrice = Math.round(base * (1 - pct));
        priceEl.textContent = formatMoney(newPrice);

        if (wasEl) {
          // Existing was = original retail. Keep it strike-through; add subscription save total.
          // savings vs retail = origRetail \u2212 newPrice
          var retailCents = parsePriceToCents(card._origWas) || base;
          if (saveEl) saveEl.textContent = 'You save ' + formatMoney(retailCents - newPrice);
        } else {
          // No was-price exists (e.g. The Nightly) \u2192 inject one showing base as strike
          var injected = document.createElement('span');
          injected.className = 'somnei-offer__price-was';
          injected.setAttribute('data-sub-injected', '1');
          injected.textContent = formatMoney(base);
          pricingEl.insertBefore(injected, priceEl);
        }
      } else {
        // Restore original markup
        priceEl.textContent = card._origPrice;
        if (wasEl && card._origWas) wasEl.textContent = card._origWas;
        if (saveEl && card._origSave) saveEl.textContent = card._origSave;
        var injectedWas = pricingEl.querySelector('[data-sub-injected]');
        if (injectedWas) injectedWas.remove();
      }
    });
  };

  function parsePriceToCents(text) {
    if (!text) return 0;
    var m = String(text).match(/([0-9]+(?:\.[0-9]+)?)/);
    return m ? Math.round(parseFloat(m[1]) * 100) : 0;
  }

  OfferPicker.prototype.addToCart = function () {
    var self = this;
    var offer = this._getSelectedOffer();
    if (!offer || !offer.variantId) {
      showError(this.errorEl, 'Please configure offer variant IDs in the theme editor.');
      return;
    }

    var isSub = !!(this.subInput && this.subInput.checked);
    // Card-based subscription (blades Subscribe & Save tier): the selected card itself
    // carries data-selling-plan-id \u2014 no legacy sub toggle involved, price is the variant's own.
    var cardSub = !!offer.sellingPlanId;
    var pct = this.discountPct / 100;
    var finalCents = isSub ? Math.round(offer.basePriceCents * (1 - pct)) : offer.basePriceCents;

    // Build cart line item
    var item = {
      id: offer.variantId,
      quantity: (window.__somneiQty || 1),
      properties: {
        _subscription: (isSub || cardSub) ? 'true' : 'false'
      }
    };
    if (offer.pack) item.properties._pack = offer.pack;
    if (offer.was)  item.properties._was = offer.was;
    if (isSub || cardSub) {
      item.properties._frequency = 'Every 30 days';
    }
    // Seal Subscriptions path: attach the selling plan whenever the offer carries one
    if (offer.sellingPlanId) {
      item.selling_plan = offer.sellingPlanId;
    }

    this._setLoading(true);
    if (this.errorEl) hideError(this.errorEl);

    // Main product + its free gifts in ONE request (was 3 sequential requests \u2248 4s of
    // drawer spinner). The reconciler self-heals any drift (caps, repeat adds, partials).
    var addItems = [item].concat(oneShotGiftItems(offer.variantId, item.quantity));
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: addItems })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'Could not add to cart.'); });
        return res.json();
      })
      .then(function () {
        // If subscription + no Seal selling plan, set cart attribute so checkout URL applies discount
        if (isSub && !offer.sellingPlanId) {
          return self._setCartAttribute('discount_code', self.discountCode);
        }
        // Otherwise, clear any stale discount attribute (e.g., user previously subscribed, then unchecked)
        if (!isSub) return self._setCartAttribute('discount_code', '');
        return null;
      })
      .then(function () {
        KlaviyoTracker.trackAddToCart({
          variantId: offer.variantId,
          priceCents: finalCents,
          label: offer.label,
          isSubscription: isSub
        });
        if (self.cartDrawer) self.cartDrawer.open();
      })
      .catch(function (err) {
        var msg = (err && err.message) ? err.message : 'Something went wrong. Please try again.';
        showError(self.errorEl, msg);
      })
      .finally(function () { self._setLoading(false); });
  };

  OfferPicker.prototype._setCartAttribute = function (key, value) {
    var attrs = {};
    attrs[key] = value || '';
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes: attrs })
    });
  };

  OfferPicker.prototype._setLoading = function (on) {
    this.atcBtns.forEach(function (btn) {
      if (on) {
        // Swap label to "Adding\u2026" while the cart call runs; original markup restored after
        // (buttons like the B/A CTA carry inner spans/svg, hence save/restore not text-set).
        if (!btn._somneiIdleHtml) btn._somneiIdleHtml = btn.innerHTML;
        btn.innerHTML = '<span class="somnei-atc-adding">Adding&hellip;</span>';
        btn.classList.add('is-loading'); btn.setAttribute('disabled', 'disabled');
      } else {
        if (btn._somneiIdleHtml) { btn.innerHTML = btn._somneiIdleHtml; btn._somneiIdleHtml = null; }
        btn.classList.remove('is-loading'); btn.removeAttribute('disabled');
      }
    });
  };

  // ---------------------------------------------------------------------------
  // StickyAtc
  // ---------------------------------------------------------------------------

  function StickyAtc() {
    this.bar     = document.getElementById('somnei-sticky-atc');
    this.trigger = document.getElementById('somnei-offer-picker');
    this.init();
  }

  StickyAtc.prototype.init = function () {
    if (!this.bar || !this.trigger) return;
    var self = this;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) self.bar.classList.remove('is-visible');
        else self.bar.classList.add('is-visible');
      });
    }, { threshold: 0.1 });
    observer.observe(this.trigger);
  };

  // ---------------------------------------------------------------------------
  // ReviewsGallery \u2014 paginate review cards ("See more" reveals next batch)
  // ---------------------------------------------------------------------------

  function initReviewsGallery() {
    var galleries = document.querySelectorAll('[data-reviews-gallery]');
    galleries.forEach(function (gallery) {
      var batch = parseInt(gallery.getAttribute('data-batch-size'), 10) || 3;
      var btn   = gallery.querySelector('[data-show-more-reviews]');
      var labelEl = gallery.querySelector('[data-show-more-label]');
      if (!btn) return;

      function allCards() { return gallery.querySelectorAll('.somnei-review'); }
      function hiddenCards() { return gallery.querySelectorAll('.somnei-review.is-hidden'); }

      function updateUi() {
        var hidden = hiddenCards();
        if (hidden.length === 0) {
          btn.setAttribute('data-mode', 'collapse');
          if (labelEl) labelEl.textContent = 'Show less';
        } else {
          btn.setAttribute('data-mode', 'expand');
          if (labelEl) labelEl.textContent = 'See more reviews';
        }
      }

      function expand() {
        var hidden = hiddenCards();
        for (var i = 0; i < Math.min(batch, hidden.length); i++) {
          hidden[i].classList.remove('is-hidden');
          hidden[i].classList.add('is-revealing');
          (function (card) {
            setTimeout(function () { card.classList.remove('is-revealing'); }, 500);
          })(hidden[i]);
        }
        updateUi();
      }

      function collapse() {
        var cards = allCards();
        for (var i = 0; i < cards.length; i++) {
          if (i >= batch) cards[i].classList.add('is-hidden');
        }
        updateUi();
        // Scroll the gallery back into view so user isn't lost in whitespace
        var top = gallery.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }

      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-mode') || 'expand';
        if (mode === 'collapse') collapse();
        else expand();
      });

      updateUi();
    });
  }

  // ---------------------------------------------------------------------------
  // BundleToRitualLinks \u2014 clicking a bundle item opens + scrolls to the
  // matching ritual step
  // ---------------------------------------------------------------------------

  function initBundleToRitualLinks() {
    var links = document.querySelectorAll('[data-jump-ritual]');
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var key = link.getAttribute('data-jump-ritual');
        var target = document.getElementById('somnei-ritual-' + key);
        if (!target) return;
        // Open the matching <details> step
        if (target.tagName === 'DETAILS') target.open = true;
        // Smooth scroll, offset 80px for sticky header
        var top = target.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: top, behavior: 'smooth' });
        // Brief highlight pulse to draw the eye
        target.classList.add('is-highlighted');
        setTimeout(function () { target.classList.remove('is-highlighted'); }, 1500);
      });
    });
  }

  // ---------------------------------------------------------------------------
  // ScrollToReviews \u2014 wire "Jump to reviews" link smooth scroll
  // ---------------------------------------------------------------------------

  function initScrollToReviews() {
    var triggers = document.querySelectorAll('[data-scroll-to-reviews]');
    triggers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        var target = document.querySelector('#somnei-reviews, .somnei-reviews, [data-reviews-anchor]');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // ---------------------------------------------------------------------------
  // HorizonCartIconHijack \u2014 make Horizon's existing cart icon open Somnei drawer
  // ---------------------------------------------------------------------------

  function hijackHorizonCartIcon(cartDrawer) {
    // Cover both Horizon variants: drawer button and link
    var selectors = [
      'a.action__cart',                                  // when cart_type != drawer
      '.header-actions__cart-icon',                      // generic icon
      'cart-drawer-component button',                    // Horizon drawer trigger
      'cart-icon'                                        // custom element
    ];
    var seen = [];
    selectors.forEach(function (sel) {
      var nodes = document.querySelectorAll(sel);
      nodes.forEach(function (node) {
        // Bind on closest clickable parent (or the node itself)
        var clickable = node.closest('a, button') || node;
        if (seen.indexOf(clickable) !== -1) return;
        seen.push(clickable);
        clickable.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          cartDrawer.open();
        }, true); // capture phase to beat Horizon's handlers
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Init
  // ---------------------------------------------------------------------------

  function initProductGallery() {
    var main = document.querySelector('[data-gallery-main]');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    if (!main || thumbs.length < 2) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (!full) return;
        main.removeAttribute('srcset');
        main.src = full;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var cartDrawer = new CartDrawer();
    window.SomneiCartDrawer = cartDrawer;

    // Cart-page gift integrity: the full /cart page has no reconciler, so a free gift can
    // strand there after its qualifying product is removed (gift lines are locked, no \u00d7 to
    // remove). Run one reconcile pass on cart-page load; reload only if a line actually
    // changed (not label re-stamps) so the server-rendered page reflects the fixed cart \u2014
    // count-gated so it can never loop.
    var isCartPage = !!document.querySelector('main#MainContent[data-template="cart"]') ||
                     location.pathname.replace(/\/+$/, '') === '/cart';
    if (isCartPage) {
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var before = cart.item_count;
          return cartDrawer.reconcileGift(cart).then(function () {
            var after = (cartDrawer._lastCart && cartDrawer._lastCart.item_count);
            if (typeof after === 'number' && after !== before) location.reload();
          });
        })
        .catch(function () {});
    }

    // Simple single-product PDP (Cream / Bath Flakes) add-to-cart \u2192 adds variant + opens the drawer.
    document.querySelectorAll('[data-simple-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!vid) return;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () { btn.disabled = false; cartDrawer.refresh(); cartDrawer.open(); })
          .catch(function () { btn.disabled = false; });
      });
    });

    var pickerRoot = document.getElementById('somnei-offer-picker');
    if (pickerRoot && pickerRoot.querySelector('[data-offer]')) {
      var offerPicker = new OfferPicker(pickerRoot);
      offerPicker.cartDrawer = cartDrawer;

      document.querySelectorAll('[data-atc]').forEach(function (btn) {
        btn.addEventListener('click', function () { offerPicker.addToCart(); });
      });

      new StickyAtc();
    }

    initScrollToReviews();
    initReviewsGallery();
    initBundleToRitualLinks();
    initProductGallery();
    hijackHorizonCartIcon(cartDrawer);

    document.querySelectorAll('[data-open-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); cartDrawer.open(); });
    });

    // Preload cart state so cart icon badge is accurate on initial page load
    cartDrawer.refresh = (function (origRefresh) {
      return function () { return origRefresh.call(cartDrawer); };
    })(cartDrawer.refresh);
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartDrawer._lastCart = cart;
        cartDrawer.updateCartIconBadge(cart);
        // Warm the thumbnail cache so the first drawer open paints images instantly
        (cart.items || []).forEach(function (i) { if (i.image) { var im = new Image(); im.src = cartThumb(i.image); } });
      })
      .catch(function () {});
  });
})();
